/**
 * Zurück/Weiter-Navigation der Wizard-Schritte (Schritt 3 hat stattdessen den
 * Start-Button in `StepCostPreview`).
 */

import { useTranslation } from 'react-i18next'

import { EID } from '@/lib/element-ids.registry'

interface WizardFooterNavProps {
  step: number
  onBack: () => void
  onNext: () => void
  nextDisabled: boolean
}

export function WizardFooterNav({ step, onBack, onNext, nextDisabled }: WizardFooterNavProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-3 border-t border-neutral-100 pt-4 dark:border-neutral-800">
      {step > 0 && (
        <button
          type="button"
          id={EID['text-bulk-wizard-back-btn']}
          onClick={onBack}
          className="rounded-md border border-neutral-300 px-4 py-2 text-sm text-neutral-700 dark:border-neutral-700 dark:text-neutral-300"
        >
          {t('common.back')}
        </button>
      )}
      {step < 2 && (
        <button
          type="button"
          id={EID['text-bulk-wizard-next-btn']}
          onClick={onNext}
          disabled={nextDisabled}
          className="ml-auto rounded-md bg-orange-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
        >
          {t('common.next')}
        </button>
      )}
    </div>
  )
}
